import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from '../button/Button';
import Icon from '../icon/Icon';

const FilterTag = ({ children, className, error, onClick, ...props }) => (
  <Button
    className={classnames('gridwall__filter_tag_new mr1-sm prl1-sm', className, { error })}
    onClick={onClick}
    {...props}
  >
    <span className='u-capitalize'>{children}</span>
    <Icon name='filled-x' isLight alt='remove' />
  </Button>
);

FilterTag.defaultProps = {
  className: '',
  error: false,
  onClick: null
};

FilterTag.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  error: PropTypes.bool,
  onClick: PropTypes.func
};

export default FilterTag;
